/* ============================================================
   REGINA – Globales Theme-JavaScript
   assets/theme-base.js
   ------------------------------------------------------------
   Einmal in layout/theme.liquid geladen. Aktiviert die
   Scroll-Einblendung für ALLE Elemente mit der Klasse .reveal,
   egal aus welcher Section sie stammen.
   ============================================================ */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var items = document.querySelectorAll('.reveal');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  items.forEach(function (el) { io.observe(el); });

  // Shopify Theme-Editor: neu geladene/verschobene Sections sofort sichtbar machen
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('in');
    });
  });
})();
